var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author"},[_c('h2',[_vm._v("Author id: "+_vm._s(_vm.$route.params.id))]),_c('h4',[_vm._v(" Author name: "+_vm._s(_vm.author.FirstName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }